var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loaded)?_c('DoughnutChart',{staticClass:"chart",style:(_vm.styleChart),attrs:{"chart-data":_vm.datacollection,"options":_vm.options}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }